export var StudyRead;
(function (StudyRead) {
    let status;
    (function (status) {
        status["DRAFT"] = "draft";
        status["IN_PROGRESS"] = "in_progress";
        status["VALIDATED"] = "validated";
        status["CANCELED"] = "canceled";
        status["COMPLETED"] = "completed";
    })(status = StudyRead.status || (StudyRead.status = {}));
})(StudyRead || (StudyRead = {}));
